<!-- =========================================================================================
  File Name: MemberEdit.vue
  Description: Member Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-member-edit">

    <vs-alert color="danger" title="Member Not Found" :active.sync="member_not_found">
      <span>Member record with id: {{ $route.params.userID }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-member-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <!-- <vx-card v-if="member_data"> -->
    <vx-card title="회원 상세 정보" class="mb-base" v-if="member_data">
      <member-edit-form class="mt-4" :data="member_data" />

    </vx-card>
  </div>
</template>

<script>
import MemberEditForm  from './MemberEditForm.vue'
import { fetchData } from '@/api/module'

export default {
  components: {
    MemberEditForm
  },
  data () {
    return {
      member_data: null,
      member_not_found: false
    }
  },
  async created () {
    try {
      const userID = this.$route.params.userID
      const { data } = await fetchData(`member/${userID}`)
      // console.log(data);
      this.member_data = data.data

    } catch (error) {
      
      this.$vs.notify({
        title: 'Error',
        text: error.response.data.msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      }) 
    }
  } 
}

</script>
